<template>
  <!-- company-info-view .civ -->
  <div class="civ">
    <div class="header-tool" style="    min-height: 107px;">
      <div class="header-tool-info">
        <Breadcrumb>
          <BreadcrumbItem>Exhibition Center</BreadcrumbItem> 
          <BreadcrumbItem>Company Information</BreadcrumbItem>
        </Breadcrumb>
        <div data-v-6d8f409f="" class="header-tool-title">Company Information</div>
      </div>
      <!-- <div v-show="String(showTabs) === '4' && invoiceAlter" class="header-tool-box">
        <div class="htb-item" @click="setInvoiceAlter(false);">
          <span>返回</span>
        </div>
      </div> -->
    </div>
    <div class="header-tabs">
      <Tabs :animated="false" @on-click="switchBrand" v-model="showTabs">
        <TabPane label="Basic Information" name="1">
          <companyInfoBasic ref="companyInfoBasic" v-if="String(showTabs) === '1'" />
        </TabPane>
        <!-- <TabPane label="认证信息" name="2">
          <companyInfoAuth ref="companyInfoAuth" v-if="String(showTabs) === '2'" />
        </TabPane> -->
        <TabPane label="Contact Information" name="2">
          <companyInfoLink ref="companyInfoLink" v-if="String(showTabs) === '2'" />
        </TabPane>
        <!-- <TabPane label="发票信息" name="3">
          <companyInfoInvoice ref="companyInfoInvoice" v-if="String(showTabs) === '3'" />
        </TabPane> -->
      </Tabs>
    </div>
    <Contact />
  </div>
</template>

<script>
import companyInfoBasic from "./subpages/company-info-basic/company-info-basic.vue";
import companyInfoAuth from "./subpages/company-info-auth/company-info-auth.vue";
import companyInfoInvoice from "./subpages/company-info-invoice/company-info-invoice.vue";
import companyInfoLink from "./subpages/company-info-linkman/company-info-linkman.vue";
import Contact from "@components/En/Contact/Contact";
import { mapGetters, mapMutations } from "vuex";

export default {
  name: "company-info",
  data() {
    return { 
      showTabs: "1",
    };
  },
  // watch: {
  //   $route(to,from){
  //     this.setInvoiceAlter(false);
  //   }
  // },
  // computed: {
  //   ...mapGetters({
  //     invoiceAlter: "companyInfoModule/getInvoiceAlter"
  //   }),
  // },
  components: {
    companyInfoBasic,
    companyInfoAuth,
    companyInfoInvoice,
    companyInfoLink,
    Contact
  },
  created() {
    document.title = "国际焙烤展 - 公司信息";
    this.changeTab();
    // this.setInvoiceAlter(false);
  }, 
  methods: {
    ...mapMutations({
      setInvoiceAlter: "companyInfoModule/setInvoiceAlter"
    }),
    changeTab() {
      let query = this.$route.query; 
      if (query && query.type && query.type === "basic") {
        this.showTabs = "1"; 
      }  else if (query && query.type && query.type === "link") { 
        this.showTabs = "2";
      } else if (query && query.type && query.type === "invoice") { 
        this.showTabs = "3";
      }
    },
    switchBrand(name) {
      if (name === "1") {
        this.$router.push(`${this.$route.path}?type=basic`);
      }  else if (name === "2") {
        this.$router.push(`${this.$route.path}?type=link`);
      } else if (name === "3") {
        this.$router.push(`${this.$route.path}?type=invoice`);
      }
    }
  }
};
</script>

<style scoped lang="scss"> 
</style>
